import { render, staticRenderFns } from "./bulk-shipping.vue?vue&type=template&id=52a28fbe&scoped=true&"
import script from "./js/bulk-shipping.js?vue&type=script&lang=js&"
export * from "./js/bulk-shipping.js?vue&type=script&lang=js&"
import style0 from "./bulk-shipping.vue?vue&type=style&index=0&id=52a28fbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a28fbe",
  null
  
)

export default component.exports